import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { StyledMessageToggler, styledSystemKeys } from "./message.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function MessageToggle(props) {
  var id = props.id,
    icon = props.icon,
    open = props.open,
    onToggle = props.onToggle,
    inverted = props.inverted;
  return /*#__PURE__*/_jsx(StyledMessageToggler, _objectSpread({
    id: id,
    label: "Aktivera f\xF6r att visa dold information",
    icon: icon,
    "aria-controls": "".concat(id, "-section"),
    "aria-expanded": open,
    active: open,
    "data-components": "accordion",
    onClick: onToggle,
    inverted: inverted
  }, extendedSystemStylesProps(styledSystemKeys, props)));
}, function (prev, curr) {
  return equals(prev.valid, curr.valid) && equals(prev.open, curr.open);
});